/* eslint-disable @typescript-eslint/member-delimiter-style */
import { Injectable } from '@angular/core';
import * as turf from '@turf/turf';
// import L from 'leaflet';

declare let L: any;

@Injectable({
    providedIn: 'root'
})
export class MapHelperService {

    constructor() { }

    generateLayerFromGeoJSON(map: any, geoJSON: any, options: { tooltipClass?, minZoom, pane?, labelPane? } = { pane: '', labelPane: '', tooltipClass: 'bmap-label', minZoom: 20 }): any {
        if (!geoJSON) {
            return;
        }
    
        let featureGroup = new L.FeatureGroup();
    
        try {
            featureGroup = map.geoJSON(geoJSON, { pane: options.pane });
        } catch (e) {
            throw new Error(`Failed to parse GeoJSON: ${e.message}`);
        }
    
        let layerIndex = 0;
        featureGroup.eachLayer((layer) => {
            const currentIndex = layerIndex++;
            layer.defaultStyle = {
                'opacity': layer.options.opacity,
                'fillOpacity': layer.options.fillOpacity,
            };

            let center = null;
            if (typeof layer.getBounds === 'function') {
                const bounds = layer.getBounds();
                const boundsValid = bounds && typeof bounds.isValid === 'function' ? bounds.isValid() : true;
                if (!bounds || !boundsValid) {
                    console.warn('[MapHelper] Invalid bounds for GeoJSON layer', {
                        index: currentIndex,
                        name: layer.feature?.properties?.name,
                        geometryType: layer.feature?.geometry?.type,
                        geometry: layer.feature?.geometry
                    });
                    return;
                }
                center = bounds.getCenter();
            } else if (typeof layer.getLatLng === 'function') {
                center = layer.getLatLng();
            }

            if (!center) {
                console.warn('[MapHelper] Unable to resolve center for GeoJSON layer', {
                    index: currentIndex,
                    name: layer.feature?.properties?.name,
                    geometryType: layer.feature?.geometry?.type,
                    geometry: layer.feature?.geometry
                });
                return;
            }

            layer.tooltipContainer = L.swoopyArrow(center, center, {
                label: layer.feature.properties.name,
                minZoom: options.minZoom,
                opacity: 0.7,
                labelFontSize: 13,
                hideArrowHead: true,
                labelColor: '#3f3f3f',
                labelClassName: 'map-label',
                color: '#039960',
                maxZoom: 29,
                factor: 0.0,
                weight: 0
            }).addTo(map);
        });
    
        return featureGroup;
    }
    

    removeMapLabels(featureGroup: any): void {
        featureGroup.eachLayer((layer) => {
            layer.tooltipContainer?.remove();
        });
    }

    removeGeoJSONFeatures(map: any, featureGroup: any): void {
        map.removeLayer(featureGroup);
    }


    updateGeoJSONLayer(featureGroup: any, style: any = {}): void {

        featureGroup.eachLayer((layer) => {
            layer.setStyle(style);
        });

    }

    saveLayerToGeoJSON(map: any, layers: any): string {
        const collection = {
            'type': 'FeatureCollection',
            'features': []
        };

        layers.eachLayer((layer) => {

            const l = map.layerToGeoJSON(layer);
            collection.features.push(l);
        });

        return JSON.stringify(collection, null, 1);
    }


    public showGeoJSONFeatures(featureGroup: any, show: boolean): void {
        featureGroup.eachLayer((layer) => {
            if (layer.feature) {

                const style = Object.assign({}, layer.defaultStyle);
                if (!show) {
                    style.opacity = 0;
                    style.fillOpacity = 0;
                }
                if (typeof layer.setStyle === 'function') {
                    layer.setStyle(style);
                }
            }

        });

    }

}
